import { Component } from '@angular/core';
import { LoadingController, NavController, NavParams, ToastController } from 'ionic-angular';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Globals } from "../../../../globals";
import { ProvidersServices } from "../../../providers/services";
import { ExpensesDenoCreateSelectDenoPage } from '../expenses-deno-create-select-deno/expenses-deno-create-select-deno';
import { ProvidersCreateDataPage } from '../../../providers/providers-create/providers-create-data/providers-create-data';
import { DeliberyNoteServices } from '../../../delibery_note/services';
import { TranslateService } from '@ngx-translate/core';

/**
 * Pantalla para crear un nuevo plato o update de uno existente
 * En el params recibimos si es un plato existente o uno nuevo. En caso de ser
 * UPDATE tenenmos que rellenar los campos del formulario
 */

@Component({
    selector: 'page-expenses-deno-create-data.html',
    templateUrl: 'expenses-deno-create-data.html',
})
export class ExpensesDenoCreateDataPage {
    public form: FormGroup;
    expenses_uid: any;
    update_state: boolean = false;
    base: any;
    tax: any;
    total: any;
    provider: any;

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public loadingCtrl: LoadingController,
        public fb: FormBuilder,
        public globals: Globals,
        private toastCtrl: ToastController,
        private providersServices: ProvidersServices,
        private deliberyNoteServices: DeliberyNoteServices,
        public translate: TranslateService) {

        //this.globals.GAtrackView('Income/Expenses', 'Income/Expenses - Create expenses', this.globals.restaurant.email);

        //Params
        this.update_state = this.navParams.get('update_state');
        this.expenses_uid = this.navParams.get('expenses_uid');
        this.provider = this.navParams.get('provider');

        //d
        let loadingPopup = this.loadingCtrl.create({
            spinner: 'crescent',
            content: this.translate.instant('instant-cargando-proveedores')
        });
        loadingPopup.present();
        this.providersServices.getListProviders(this.globals.restaurant_uid);
        loadingPopup.dismiss();

        this.form = fb.group({
            number: ['', Validators.compose([Validators.required])],
            date: ['', Validators.compose([Validators.required])],
            business_name: [''],
            provider: [this.provider, Validators.compose([Validators.required])],
            payment_method: ['', Validators.compose([Validators.required])],
            category: [''],
            payment: [false],
        });
    }

    submit() {
        if (this.form.valid) {
            if (!this.update_state) {
                this.insert();
            } else {
                //this.update();
            }
        } else {
            let toast = this.toastCtrl.create({
                message: this.translate.instant('instant-completa-datos-continuar'),
                duration: 3000,
                position: 'bottom'
            });
            toast.present();
        }
    }

    insert() {
        var pro = this.form.value.provider.split(',;,');
        var p_name = pro[1];
        var p_uid = pro[0];
        this.deliberyNoteServices.uid_provider_selected = p_uid;
        this.globals.GAtrackView('ProviderOrders', 'ProviderOrders - Name - Create', this.globals.restaurant.email, 'Create/Update', 'Create name provider order', 'ProviderOrders', this.form.value.number);
        //send data next page
        this.navCtrl.push(ExpensesDenoCreateSelectDenoPage, {
            number: this.form.value.number,
            date: this.form.value.date,
            business_name: p_name,
            provider_uid: p_uid,
            payment_method: this.form.value.payment_method,
            category: this.form.value.category,
            payment: this.form.value.payment,
        });
    }

    openCreateProvider() {
        this.providersServices.quick_create = true;
        this.navCtrl.push(ProvidersCreateDataPage, {
            update_state: false,
        });
    }


}


// WEBPACK FOOTER //
// ./src/pages/income-expenses/expenses-deno-create/expenses-deno-create-data/expenses-deno-create-data.ts